import store from '@/store'
import {firstNonBlank, firstNonEmpty} from '@/utils/arrays'
import { some, includes, trim, get } from 'lodash'

export function getPorts () {
  return store.getters.ports.ports
}

export function getPortById (id) {
  return store.getters.ports.portsMap[id]
}

export function getChildPortIds (id, ak) {
  const ports = store.getters.ports.cityPortMap[id]
  if (!ports) {
    return []
  }
  return ak ? ports.filter(p => isPortPermitForAk(p.id, ak)).map(p => p.id) : ports.map(p => p.id)
}

function getCode (port) {
  return firstNonBlank(port.tch, port.iata, port.aftn, port.icao)
}

export function getPortLabels (port, lng) {
  return {
    'value': port.id,
    'label': (lng === 'ru') ? firstNonEmpty(port.nameRu, port.nameEn) : firstNonEmpty(port.nameEn, port.nameRu),
    'code': getCode(port),
    'searchString': ('' + '|' + port.nameRu + '|' + port.nameEn + '|' + port.tch + '|' + port.iata + '|' + port.aftn + '|' + port.icao).toUpperCase()
    //, 'rawValue': p
  }
}

// TODO: replace getPortById in code with this method
export function resolvePortLabels (portId) {
  const port = getPortById(portId)
  return get(port, 'labels')
}

export function filterPorts (query) {
  // TODO: limit max results
  let searchQuery = trim(query).toUpperCase()
  if (searchQuery === '') {
    return store.getters.ports.ports
  }

  return store.getters.ports.ports.filter(p => {
    return p.labels.searchString.indexOf(searchQuery) >= 0
  })
}

export function searchPortsWithAny (substrings) {
  if (substrings == null) {
    return []
  }
  if (typeof substrings === 'string') {
    substrings = [substrings]
  }
  return store.getters.ports.ports.filter(p => {
    return some(substrings, (el) => includes(p.labels.searchString, el))
  })
}

export function getRecentPorts (maxCount) {
  if (maxCount) {
    return (store.getters.ports.recentPorts || []).slice(0, maxCount)
  }
  return store.getters.ports.recentPorts
}

export function addRecentPortById (id) {
  store.dispatch('ports/addRecentPort', getPortById(id))
}

export function isPortPermitForAk (portId, ak) {
  const port = getPortById(portId)
  if (!port.isPort) {
    const childPorts = store.getters.ports.cityPortMap[portId] || []
    return childPorts.filter(p => p.aircompanies.length === 0 || p.aircompanies.includes(ak)).length > 0
  }
  return port.aircompanies.length > 0 ? port.aircompanies.includes(ak) : true
}

export function choosePortForAk (portId, ak) {
  // expected that port already check for validness
  const port = getPortById(portId)
  if (port.isPort) {
    return portId
  }
  const childPorts = store.getters.ports.cityPortMap[portId] || []
  // get port with current ak
  const ports = childPorts.filter(p => p.aircompanies.includes(ak))
  if (ports.length > 0) {
    return ports[0].id
  }
  // if not found - get any port without ak
  return childPorts.filter(p => p.aircompanies.length === 0)[0].id
}

export function isPortChildOf (portId, parentPortId) {
  return getPorts().filter(p => p.parentId === parentPortId).map(p => p.id).includes(portId)
}

export function isPortEqualOrChildOf (portId, parentPortId) {
  return portId === parentPortId || isPortChildOf(portId, parentPortId)
}

export function reloadPorts () {
  return store.dispatch('ports/reloadPorts')
}



// WEBPACK FOOTER //
// ./src/utils/ports.js